<template>
    <div>
      <Header/>
      <vendorAssignmentSearch/>
    </div>
</template>
<script>
// @ add advance search component to page alogn with header
import Header from '@/components/header.vue'
import vendorAssignmentSearch from '@/components/vendorAssignmentSearch.vue'
export default {
  name: 'vendorAssignmentHome',
  components: {
    Header,
    vendorAssignmentSearch
  }
}
</script>
